"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useEffect } from "react";
const TOUR_JOYRIDE_PORTAL_ID = "react-joyride-portal";
function keepTourJoyridePortalInteractive() {
  const portal = document.getElementById(TOUR_JOYRIDE_PORTAL_ID);
  if (!portal) {
    return;
  }
  portal.removeAttribute("aria-hidden");
  portal.removeAttribute("inert");
  portal.style.pointerEvents = "auto";
}

/** Modal hosts set body pointer-events and aria-hide siblings; Joyride portals to body. */
export function useKeepTourJoyridePortalInteractive(t0) {
  const $ = _c(3);
  const {
    enabled
  } = t0;
  let t1;
  let t2;
  if ($[0] !== enabled) {
    t1 = function syncTourJoyridePortalInteractivity() {
      if (!enabled) {
        return;
      }
      keepTourJoyridePortalInteractive();
      const observer = new MutationObserver(_temp);
      observer.observe(document.body, {
        attributeFilter: ["aria-hidden", "inert"],
        attributes: true,
        childList: true,
        subtree: true
      });
      return () => {
        observer.disconnect();
      };
    };
    t2 = [enabled];
    $[0] = enabled;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
}
function _temp() {
  keepTourJoyridePortalInteractive();
}